import { render, staticRenderFns } from "./QuizForm.vue?vue&type=template&id=5ff93fa8&scoped=true&"
import script from "./QuizForm.vue?vue&type=script&lang=js&"
export * from "./QuizForm.vue?vue&type=script&lang=js&"
import style0 from "./QuizForm.vue?vue&type=style&index=0&id=5ff93fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff93fa8",
  null
  
)

export default component.exports